import { Navigate } from "react-router-dom";

export const OpenRoutes = ({ children }) => {
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  if (user?.token !== undefined) {
    // Role-based redirection
    if (user.role === "admin") {
      return <Navigate to="/admin" replace={true} />;
    } else if (user.role === "superAdmin") {
      return <Navigate to="/superAdmin" replace={true} />;
    } else if (user.role === "merchant") {
      return <Navigate to="/merchant" replace={true} />;
    } else if (user.role === "deliveryBoy") {
      return <Navigate to="/delivery" replace={true} />;
    }
  }

  return children;
};
